/**
 * 获取用户
 */
export const thirdPayLogin = '/uout/auth/thirdPay/login';
/**
 * 直接登录
 */
export const thirdPayDrLogin = '/uout/auth/third/pay/direct/login';
/**
 * 币种和档位映射关系
 */
export const getCurrencyGear = '/center/thirdPay/currency/gear';
/**
 * 支付方式列表获取
 */
export const getAllPayMode = '/center/thirdPay/pay/mode';
/**
 * 三方支付商品列表获取
 */
export const serverIapList = '/center/thirdPay/server/iap/list';
/**
 * 三方支付消费记录
 */
export const getThirdPayOrderList = '/center/thirdPay/purchaseList/get';
/**
 * 创建三方支付订单
 */
export const createThirdPayOrder = '/pout/thirdPay/order/create';
/**
 * 三方订单校验
 */
export const verifyThirdPayOrder = '/pout/thirdPay/order/verify';
/**
 * 执行请款
 */
export const thirdPayOrderRequestPay = '/pout/thirdPay/order/requestPay';
/**
 * 查询商品详情
 */
export const getThirdPayGoodsDetail = '/pout/third/pay/goods/get/detail';
/**
 * 获取游戏角色上一次支付成功的支付方式
 */
export const getDefaultPayment = '/center/thirdPay/role/default/payment';
/**
 * 基于 token 列表检验合法角色 token
 */
export const checkRolesToken = '/center/thirdPay/check/roles/token';
/**
 * 三方支付查询子订单
 */
export const orderSublist = '/center/thirdPay/purchase/order/sublist';
/**
 * 三方商城获取用户 礼金 剩余数
 */
export const getUserPointData = '/pout/thirdPay/point/get/user/remaining/point/count';
/**
 * 三方商城获取 礼金 使用规则说明
 */
export const getUserPointRule = '/pout/thirdPay/point/get/activity/rule/usage/statement';
/**
 * 三方商城获取 礼金 使用规则开关
 */
export const getUserPointSwitch = '/pout/thirdPay/point/get/activity/rule/usage/switch';
/**
 * 三方商城获取邮箱验证码
 */
export const getEmailCode = '/pout/thirdPay/auth/info/send/verify/email/code';
/**
 * 三方商城设置三方支付安全邮箱
 */
export const setPayEmail = '/pout/thirdPay/auth/info/set/user/pay/email';
/**
 * 三方商城校验用户是否为首次支付
 */
export const getPointInit = '/pout/thirdPay/auth/info/check/initial/point/pay';
/**
 * 三方商城校验用户是否已经设置支付密码
 */
export const getPayPwdFlag = '/pout/thirdPay/auth/info/check/pay/password/configured';
/**
 * 三方商城校验用户是否设置安全邮箱
 */
export const getEmailFlag = '/pout/thirdPay/auth/info/check/pay/email/configured';
/**
 * 三方商城设置三方支付支付密码
 */
export const setPayPwd = '/pout/thirdPay/auth/info/set/user/pay/password';
/**
 * 三方商城修改三方支付支付密码
 */
export const changePayPwd = '/pout/thirdPay/auth/info/modify/user/pay/password';
/**
 * 查询三方支付安全邮箱地址
 */
export const getUserPayEmail = '/pout/thirdPay/auth/info/get/user/pay/email';
/**
 * 三方商城修改密码时校验支付旧密码
 */
export const checkPayPwd = '/pout/thirdPay/auth/info/check/pay/user/old/password';
/**
 * 三方商城修改密码时校验验证码
 */
export const checkPayEmail = '/pout/thirdPay/auth/info/check/pay/user/email/code';
/**
 * 三方商城校验支付密码
 */
export const checkUPay = '/pout/thirdPay/auth/info/check/user/pay/password';
/**
 * 版本号查询
 */
export const getVersion = '/pout/thirdPay/version'
/**
 * center 模块 ParamTrackerCtrl 
 */
export const trackLog = '/center/param/track/log';
